<template>
  <div>
    <div class="card-spacing" />

    <welcome-card
      :button-route="{name: 'login'}"
      :button-text="$t('cms.signup.GoToLogin')"
    />

    <div class="card-spacing" />

    <form class="card flex column" @submit.prevent="submitSignup">
      <card-header
        :title="$t('cms.signup.SignupHeader')"
        :description="$t('cms.campaign.SignupDescription')"
        :hasInfoIcon="false"
        :hasCheckMark="false"
      >
        <template #icon>
          <icon signup xlarge />
        </template>
      </card-header>

      <div class="pa2 flex column">
        <input
          style="text-align: left;"
          v-model="name"
          name="name"
          :placeholder="$t('cms.signup.CompanyNamePlaceholder')"
          v-validate="'required'"
          class="flex grow box center_text my1"
        >
        <span>{{ errors.first('name') }}</span>

        <input
          style="text-align: left;"
          v-model="city"
          name="city"
          :placeholder="$t('cms.signup.CityPlaceholder')"
          v-validate="'required'"
          class="flex grow box center_text my1"
        >
        <span>{{ errors.first('city') }}</span>

        <input
          style="text-align: left;"
          v-model="streetAddress"
          name="streetAddress"
          :placeholder="$t('cms.signup.StreetAddressPlaceholder')"
          v-validate="'required'"
          class="flex grow box center_text my1"
        >
        <span>{{ errors.first('streetAddress') }}</span>

        <input
          style="text-align: left;"
          v-model="postcode"
          name="postcode"
          :placeholder="$t('cms.signup.PostcodePlaceholder')"
          v-validate="'required'"
          class="flex grow box center_text my1"
        >
        <span>{{ errors.first('postcode') }}</span>

        <country-select v-model="country"/>

        <currency-select v-model="currency"/>

        <timezone-select
          v-model="timezone"
          :placeholder="$t('cms.signup.TimezonePlaceholder')"
        />

        <input
          style="text-align: left;"
          v-model="userFullName"
          name="userFullName"
          :placeholder="$t('cms.signup.UserFullNamePlaceholder')"
          v-validate="'required'"
          class="flex grow box center_text my1"
        >
        <span>{{ errors.first('userFullName') }}</span>

        <input
          style="text-align: left;"
          type="email"
          v-model="email"
          name="email"
          :placeholder="$t('cms.signup.EmailPlaceholder')"
          v-validate="'required|email'"
          class="flex grow box center_text my1"
        >
        <span>{{ errors.first('email') }}</span>

        <input
          style="text-align: left;"
          type="password"
          v-model="userPassword"
          name="userPassword"
          :placeholder="$t('cms.signup.PasswordPlaceholder')"
          v-validate="'required'"
          class="flex grow box center_text my1"
        >
        <span>{{ errors.first('userPassword') }}</span>

        <input
          style="text-align: left;"
          type="password"
          v-model="confirmUserPassword"
          name="confirmUserPassword"
          :placeholder="$t('cms.signup.ConfirmPasswordPlaceholder')"
          v-validate="'required'"
          class="flex grow box center_text my1"
        >
        <span>{{ errors.first('confirmUserPassword') }}</span>

        <button
          :disabled="disabledButton"
          style="height: 40px"
          class="flex grow secondary_background white box my1"
        >
          <b>{{ $t('cms.signup.SignupButton') }}</b>
        </button>
      </div>
    </form>

    <div class="card-spacing" />

  </div>
</template>

<script>
import AuthMixin from '@/mixins/auth_mixin';
import WelcomeCard from '@/components/WelcomeCard.vue';
import CardHeader from '@/components/global/CardHeader.vue';
import TimezoneSelect from '@/components/TimezoneSelect.vue';
import CountrySelect from '@/components/CountrySelect.vue';
import CurrencySelect from '@/components/CurrencySelect.vue';

export default {
  name: 'create-account',

  components: {
    CurrencySelect, CountrySelect, TimezoneSelect, CardHeader, WelcomeCard,
  },

  mixins: [AuthMixin],

  data() {
    return {
      currency: null, // currency ID
      city: null,
      email: null,
      name: null,
      postcode: null,
      streetAddress: null,
      country: null,
      timezone: null,
      userFullName: null,
      userPassword: null,
      confirmUserPassword: null,
    };
  },

  computed: {
    validEmail() {
      return this.email && !this.errors.has('email');
    },

    disabledButton() {
      return !(
        this.validEmail
        && this.currency
        && this.city
        && this.email
        && this.name
        && this.postcode
        && this.streetAddress
        && this.country
        && this.timezone
        && this.userFullName
        && this.userPassword
        && this.confirmUserPassword
      );
    },

  },

  methods: {
    async submitSignup() {
      if (this.userPassword !== this.confirmUserPassword) {
        this.showWarningNotification(this.$t('cms.signup.PasswordsDoNotMatch'));
        return;
      }

      if (!await this.$validator.validate()) {
        return;
      }

      const input = {
        currency: this.currency,
        city: this.city,
        email: this.email,
        country: this.country,
        name: this.name,
        postcode: this.postcode,
        streetAddress: this.streetAddress,
        timezone: this.timezone,
        userFullName: this.userFullName,
        userPassword: this.userPassword,
      };
      const { data, errors } = await this.$mutate(this.$mutations.signup, { input }, null, true);

      if (!((data || {}).registerOrganization || {}).ok) {
        this.handleErrors(errors);
        return;
      }

      await this.login(this.email, this.userPassword);
    },
  },
};
</script>
